/* Front-end purchase caps.

   Reads the caps and current cart quantities emitted by
   snippets/purchase-limits.liquid (sourced from the `variant_purchase_limit`
   metaobjects) and blocks an add-to-cart submit when the cart already holds the
   maximum for that variant, sending the customer to the cart instead.

   The quantities arrive server-rendered so the very first click is already
   accurate; they are then refreshed from /cart.js on load and on every
   theme:cartchanged to catch changes made elsewhere. Keeping the count locally
   makes the decision synchronous: an over-limit submit is cancelled outright and
   anything under the limit is left completely untouched, so theme.js's AJAX add
   and the cart drawer behave exactly as before.

   Runs in the capture phase to decide before theme.js's jQuery submit handler.
   Not covered on purpose: checkout and direct AJAX/API calls. */
(function () {
    var node = document.querySelector('[data-purchase-limits]');
    if (!node) {
        return;
    }

    var data;
    try {
        data = JSON.parse(node.textContent);
    } catch (error) {
        return;
    }
    if (!data || !Object.keys(data).length) {
        return;
    }

    var caps = {};
    var counts = {};
    Object.keys(data).forEach(function (key) {
        caps[key] = parseInt(data[key].cap, 10) || 0;
        counts[key] = parseInt(data[key].inCart, 10) || 0;
    });

    function root() {
        var shopify = window.Shopify;
        if (shopify && shopify.routes && shopify.routes.root) {
            return shopify.routes.root;
        }
        return '/';
    }

    function refresh() {
        return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
                return response.json();
            })
            .then(function (cart) {
                var next = {};
                Object.keys(caps).forEach(function (key) {
                    next[key] = 0;
                });
                (cart.items || []).forEach(function (item) {
                    var key = String(item.variant_id);
                    if (key in next) {
                        next[key] += item.quantity;
                    }
                });
                counts = next;
            })
            .catch(function () {
                /* Keep the server-rendered counts. */
            });
    }

    // This theme's product form submits the variant through `<select name="id[]">`,
    // while simpler add-to-cart forms use a plain `name="id"` input.
    function readVariantId(form) {
        var field = form.querySelector('[name="id"], [name="id[]"]');
        if (!field) {
            return null;
        }
        return parseInt(field.value, 10) || null;
    }

    refresh();
    document.addEventListener('theme:cartchanged', refresh);

    document.addEventListener(
        'submit',
        function (event) {
            var form = event.target;
            if (!form || form.tagName !== 'FORM') {
                return;
            }

            // The All Points East landing page runs its own capped handler.
            if (form.hasAttribute('data-ape-buy')) {
                return;
            }

            var action = form.getAttribute('action') || '';
            if (action.indexOf('/cart/add') === -1) {
                return;
            }

            var variantId = readVariantId(form);
            if (!variantId) {
                return;
            }

            var key = String(variantId);
            var cap = caps[key];
            if (!cap || cap < 1) {
                return;
            }

            // theme.js adds one unit per submit regardless of any quantity field,
            // so "already at the cap" is the condition that bounds the total.
            if ((counts[key] || 0) < cap) {
                return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();
            window.location.href = root() + 'cart';
        },
        true
    );
})();
